module.exports = __webpack_public_path__ + "static/media/send.5034e72e.svg";